// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_3tbtVlsx7k1_IbEiqq_Qtp"};